import * as z from "zod";
import {
  dateSchema,
  referenceObject,
  requiredString,
} from "components/form/utils";

export const taskSchema = z.object({
  title: requiredString().nonempty("Title cannot be empty"),
  description: z.optional(z.string()).nullable(),
  attachments: z.array(z.any()).optional(),
  status: z.optional(z.string()).default("open"),
  assignee: referenceObject(),
  due_date: dateSchema.optional().nullable(),
});
